import { render } from "./IntPhoneNumber.vue?vue&type=template&id=d200eefa"
import script from "./IntPhoneNumber.vue?vue&type=script&lang=js"
export * from "./IntPhoneNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__